














































































































import {Component, Prop} from 'vue-property-decorator';
import BillingMixin from '@/mixins/billing-mixin';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component({
  components: {}
})
export default class ChangePlanDialogStep2 extends mixins(PlanLimitsMixin, BillingMixin) {
  @Prop()
  estimate: any;
  
  @Prop()
  selected: Billing.BillingPlan;
  
  @Prop()
  currencyFormat: string;

  get invoiceEstimate(){
    return this.estimate.invoice_estimate || this.estimate.next_invoice_estimate
  }
  
  get addons(){
    return Object.values(this.$store.state.billing.addons) as PlanAddon[]
  }
  
  get addonsStay(){
    return this.addons.filter(addon=>{
      return this.selected.limits[addon.addonName]!==true
    })
  }
  
  get addonsDeactivated(){
    return this.addons.filter(addon=>{
      return this.selected.limits[addon.addonName]===true
    })
  }

  get totalShouldBePaidOn(){
    const addonsPrice = this.addonsStay.reduce((acc,addon)=>{
      acc = +addon.addonTotalPrice + acc;
      return acc
    },0)
    return addonsPrice + this.selected.price
  }
}
